import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import * as S from './styles'

import { Modal } from '~/components'

import InicializacaoCotaComponent from './InicializacaoCotaComponent';

import api from '~/services/api';
import { toast } from 'react-toastify';
import { t } from '~/helpers';

import { Button } from '@material-ui/core';

import { resetParams } from '~/store/modules/hooks/actions'

export default function InicializacaoCota() {

    const dispatch = useDispatch();
    const modalRef = useRef(null)

    const [loadingModalRequest, setLoadingModalRequest] = useState(false);
       
    const actionsModal = useMemo(() => [
        {
            label: t('s.geral.botaoconfirmar'),
            callback: () => handleExecuteResetCotas(),
            color: 'primary',
            autoFocus: true,
        },
        {
            label: t('s.geral.botaofechar'),
            callback: () => modalRef.current.handleCloseModal(),
            color: 'secondary',
        },
    ], [])

    const handleExecuteResetCotas = useCallback(async () => {
        try {
            setLoadingModalRequest(true);

            await api.put(`resetcota`);
            dispatch(resetParams())
                        
            setLoadingModalRequest(false)
            modalRef.current.handleCloseModal()

        } catch (erros) {
            setLoadingModalRequest(false)
            erros.map((error) => toast.error(error));
        }
    }, [])


    return (
        <S.Wrapper>
            <S.ButtonWrapper>
                <Button
                    color="primary"
                    size="small"
                    variant="contained"
                    onClick={() => modalRef.current.handleOpenModal()}>
                    Reset de cotas
                </Button>
            </S.ButtonWrapper>

            <Modal
                disableBackdropClick
                disableEscapeKeyDown
                ref={modalRef}
                maxWidth="xs"
                title="Confirmação inicilizar cotas"
                component={() => <InicializacaoCotaComponent />}
                actions={actionsModal}
                loading={loadingModalRequest}
            />

        </S.Wrapper>)
}